import { memo, ReactNode, useEffect, useState } from "react";
import { FCX } from "@datassential/platform-ui-lib";
import { WindowScroller as VirtualizedWindowScroller } from 'react-virtualized';

const WindowScroller: FCX<{
    scrollerKey?: any;
    scrollerRef?: React.RefObject<HTMLDivElement>;
    element?: () => ReactNode;
}> = ({
    scrollerKey,
    scrollerRef,
    element = () => <div/>,
}) => {
    const [scrollerKeyState, setScrollerKeyState] = useState(null);

    useEffect(() => {
        setTimeout(() => {
            setScrollerKeyState(scrollerKey);
        }, 500);
    }, [scrollerKey]);

    return (
        <VirtualizedWindowScroller
            key={scrollerKeyState}
            onScroll={
                // @ts-ignore
                ({ scrollTop }) => scrollerRef.current && scrollerRef.current.scrollTo(scrollTop)
            }
        >
            {element}
        </VirtualizedWindowScroller>
    );
};

export default memo(WindowScroller);